module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAKCAYAAABrGwT5AAAA6klEQVQokZ3SrUpEURTF8d+9Gi1im64wFucNjILJr6YiM/oAitlkNjtpDJoGFA0KNn2CwaKgnCY2sYjggGC4+8JBxOAqm/Nn7QPrnFWklGQawxqWMYNxvOEOpzjBe20usuU59NCI8wMeMYVmsBd0cA1lwA4uY3GINqaxELMdvBG+1Xq5hUOMxEX76OMCnzH7wYWvh1aRUrrBbJa7iXkcZGwXVxGl1m3p/ypK7ESeWivo4hwfMbvBaw2xPYoBtnAUefbwjMXMvBEcvrCJwV9fdY8nTKpenB9fVfxSknUsqUoygVdVSc5wLCvJN0FXP2AWy75tAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/reads.png
// module id = +Ar1
// module chunks = 1